// extracted by mini-css-extract-plugin
export default {"tag":"RemoteTag-index__tag--AbvRx"};